import ServicePage from "./ServiceTemplate";
export default function MagneticFork() { return <ServicePage serviceId="magnetic-fork" />; }
